import { useMemo } from 'react'

import { PopOverItem } from 'components/PopOver/types'
import { useDialerUIContext } from 'modules/DialerClient/DialerUIContext'

const useCallOptions = () => {
  const { state } = useDialerUIContext()

  const options: PopOverItem[] = useMemo(
    () => [
      {
        icon: ['far', 'phone'],
        label: 'log_a_call_lbl',
        value: 'call-log',
      },
      {
        icon: 'headset',
        label: 'live_call',
        value: 'live-call',
        isDisabled: state.isCalling,
      },
    ],
    [state.isCalling],
  )

  return { options }
}

export type CallType = 'call-log' | 'live-call'

export default useCallOptions
